// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover[data-v-9ca4cb66]{text-align:center}.popover .fa-icon[data-v-9ca4cb66]{margin-right:.75rem}.popover .btn[data-v-9ca4cb66]{height:1em;padding:0 !important}`, "",{"version":3,"sources":["webpack://./client/components/Popovers/PopoverVerificationInfo.vue"],"names":[],"mappings":"AAGA,0BACE,iBAAA,CACA,mCACE,mBAAA,CAGF,+BACE,UAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
